<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nom</label>
      </div>
      <input v-model="dataForm.nom"
             class="form-control"
             name="terrain_nom"
             placeholder="Entrez le nom du terrain"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Adresse</label>
      </div>
      <input v-model="dataForm.adresse"
             class="form-control"
             name="terrain_adresse"
             placeholder="Entrez l'adresse ou la référence du terrain"
             type="text">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Update",
  props: {
    terrain: {
      type: Object
    }
  },
  data() {
    return {
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom: '',
        adresse: '',
        table: 'terrains',
        table_id: this.terrain.terrain_id,
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosPutData',
    ]),
    onSubmit() {
      this.resetDefaultValues()
      this.axiosPutData(this.dataForm)
          .then((data) => {
            if(data.status === 204)
              this.messageSuccess = "Terrain modifié avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de la modification du terrain !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de la modification du terrain !"
          })
    },
    resetDefaultValues() {
      if(this.dataForm.nom === '')
        this.dataForm.nom = this.terrain.nom
      if(this.dataForm.adresse === '')
        this.dataForm.adresse = this.terrain.adresse
    },
    setDefaultValues() {
      const terrain = Object.assign({}, this.terrain);
      this.dataForm.nom = terrain.nom
      this.dataForm.adresse = terrain.adresse
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/terrains/components/Update.vue